import { Dialog, DialogActions, DialogTitle } from '@mui/material';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useTranslation } from '../../../contexts/TranslationContext';
import {
  deleteModalAtom,
  selectedAccountStateAtom,
} from '../../../models/atoms/account_atoms';
import { MHMButton } from '../MHM/MHMButton';
import { account_controller } from '../../../controllers/account_controller';

export function DeleteAccountModal() {
  const { t } = useTranslation();
  const [deleteAccountModal, setDeleteAccountModal] =
    useRecoilState(deleteModalAtom);
  const selectedAccount = useRecoilValue(selectedAccountStateAtom);

  function closeModal() {
    setDeleteAccountModal(false);
  }

  function handleDelete() {
    if (selectedAccount === null) {
      return;
    }
    account_controller.delete_account(selectedAccount.id);
    closeModal();
  }

  return (
    <Dialog open={deleteAccountModal} onClose={closeModal}>
      <DialogTitle textAlign="center">{t('Confirm Deletion')}</DialogTitle>

      <DialogActions sx={{ justifyContent: 'space-between', px: 3, pb: 2 }}>
        <MHMButton onClick={closeModal} color="inherit">
          {t('Cancel')}
        </MHMButton>
        <MHMButton onClick={handleDelete} color="error">
          {t('Delete')}
        </MHMButton>
      </DialogActions>
    </Dialog>
  );
}
